import { Banner, Button, Card, Text } from '@shopify/polaris';
import { PakoLogo } from './PakoLogo';

export function TelegramAccessDenied({
  title,
  message,
  detail,
  onClose,
}: {
  title: string;
  message: string;
  detail?: string;
  onClose?: () => void;
}) {
  return (
    <div className="admin-login-screen">
      <div className="admin-login-card">
        <Card>
          <div className="admin-stack">
            <div className="admin-login-brand">
              <PakoLogo size={64} />
              <div>
                <Text as="h1" variant="headingXl">Pako AdminApp</Text>
                <Text as="p" variant="bodyMd" tone="subdued">
                  Telegram Mini App
                </Text>
              </div>
            </div>
            <Banner tone="critical" title={title}>
              <p>{message}</p>
            </Banner>
            <Text as="p" variant="bodyMd" tone="subdued">
              Якщо доступ щойно додали, поверніться в бот і натисніть «Перевірити».
            </Text>
            {detail ? (
              <Text as="p" variant="bodySm" tone="subdued">
                {detail}
              </Text>
            ) : null}
            <div className="admin-inline-actions">
              <Button onClick={() => window.location.reload()}>Спробувати ще раз</Button>
              {onClose ? (
                <Button variant="primary" onClick={onClose}>
                  Закрити Mini App
                </Button>
              ) : null}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
